import type { Page } from "../types.js";
import { useT } from "../lib/i18n/store.js";

/**
 * Segmented switcher between the public catalog and the signed-in author's own
 * novels ("My Novels"). Rendered at the top of both pages so the two read as one
 * page with a toggle. Uses role="tab" (not plain buttons) so it never collides
 * with the identically-named top-nav menu items in tests or assistive tech.
 */
export function LibraryTabs({
  active,
  onNavigate
}: {
  active: "catalog" | "profile";
  onNavigate: (page: Page) => void;
}) {
  const t = useT();
  const tabs: Array<{ key: "catalog" | "profile"; label: string }> = [
    { key: "catalog", label: t("nav.catalog") },
    { key: "profile", label: t("nav.myNovels") }
  ];
  return (
    <div className="library-tabs" role="tablist" aria-label={t("library.tabsAria")}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          className={active === tab.key ? "library-tab is-active" : "library-tab"}
          onClick={() => {
            if (active !== tab.key) onNavigate(tab.key);
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
